import { useEffect } from 'react';
import { updateUserActivity } from './UserStore';

const useActivityTracker = () => {
  useEffect(() => {
    // Activity events to track
    const activityEvents = [
      'mousedown',
      'mousemove', 
      'keypress',
      'scroll',
      'touchstart',
      'click'
    ];

    // Throttle activity updates to avoid excessive calls
    let lastUpdate = 0;
    const throttleDelay = 60000; // Update max once per minute

    const handleActivity = () => {
      const now = Date.now();
      if (now - lastUpdate > throttleDelay) {
        updateUserActivity();
        lastUpdate = now;
      }
    };

    // Add event listeners
    activityEvents.forEach(event => {
      document.addEventListener(event, handleActivity, true);
    });

    // Cleanup
    return () => {
      activityEvents.forEach(event => {
        document.removeEventListener(event, handleActivity, true);
      });
    };
  }, []);
};

export default useActivityTracker;